// Class for building a chain of CSS class names
class ClassChain {
	constructor(initialCls) {
		this.classes = [initialCls];
	}

	/**
	 * Conditionally add a class name
	 * @param {*} condition Condition to evaluate (any truthy/falsy value)
	 * @param {String} clsYes Class name to add if condition is true
	 * @param {String} clsNo Class name to add if condition is false (optional)
	 * @returns {ClassChain} Returns the current instance for chaining
	 */
	add(condition, clsYes, clsNo = '') {
		// Treat only null, undefined, empty strings and false as false; everything else is considered truthy
		const showYes =
			condition !== null && condition !== undefined && condition !== false && condition !== 0 && condition !== '';
		if (showYes) {
			if (clsYes !== null && clsYes !== undefined && clsYes !== '') {
				this.classes.push(String(clsYes));
			}
		} else {
			if (clsNo !== null && clsNo !== undefined && clsNo !== '') {
				this.classes.push(String(clsNo));
			}
		}
		return this;
	}

	toString() {
		return this.classes.join(' ');
	}
}

/**
 * Build a CSS class name string with additional classes
 * @param {String} baseClass           Base class (e.g. "menu-item")
 * @param {...String} additionalClasses Additional classes to append (e.g. "item-selected", "active")
 * @returns {ClassChain}               Instance for further chaining
 */
export const buildClass = (baseClass, ...additionalClasses) => {
	const classChain = new ClassChain(baseClass);
	additionalClasses.forEach((cls) => classChain.add(!!cls, cls));
	return classChain;
};
